import { LoaderService } from '@/app/common/services/loader/loader.service'
import { CommonModule, NgForOf, NgIf } from '@angular/common'
import { HttpErrorResponse } from '@angular/common/http'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconModule } from '@angular/material/icon'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzEmptyModule } from 'ng-zorro-antd/empty'
import { NzGridModule } from 'ng-zorro-antd/grid'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzSwitchModule } from 'ng-zorro-antd/switch'
import {
  NzNotificationModule,
  NzNotificationService
} from 'ng-zorro-antd/notification'
import { NzPaginationModule } from 'ng-zorro-antd/pagination'
import { BehaviorSubject } from 'rxjs'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzModalService } from 'ng-zorro-antd/modal'
import { NzTabsModule } from 'ng-zorro-antd/tabs'
import { NzDividerModule } from 'ng-zorro-antd/divider'
import { HeaderService } from '@/app/common/services/header/header.service'
import { NzTagModule } from 'ng-zorro-antd/tag'
import { Router, RouterModule, ActivatedRoute } from '@angular/router'
import {
  ChecklistHeaderFindAllResponse,
  HeaderTypeEnum
} from '@/app/modules/checklist-header/core/type'
import { ChecklistHeaderService } from '@/app/modules/checklist-header/core/service'
import { NzTableFilterList, NzTableModule } from 'ng-zorro-antd/table'
import { NzDropDownModule } from 'ng-zorro-antd/dropdown'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox'
import { NzInputModule } from 'ng-zorro-antd/input'
import { Location } from '@angular/common'
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import { AuthService } from '@/app/modules/auth/core/service'
import { User } from '@/app/modules/user/core/type'
import { CompanyService } from '@/app/modules/company/core/service'
import { ImagesService } from '@/app/modules/images/core/service'

@Component({
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NzGridModule,
    NzButtonModule,
    NzTagModule,
    NzDividerModule,
    NzTabsModule,
    NzButtonModule,
    NzPaginationModule,
    NzNotificationModule,
    NzLayoutModule,
    NzEmptyModule,
    NzSwitchModule,
    NzIconModule,
    MatIconModule,
    FormsModule,
    RouterModule,
    NgIf,
    NgForOf,
    NzTableModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzCheckboxModule,
    NzInputModule
  ],
  providers: [NzModalService]
})
export class ListChecklistHeaderComponent implements OnInit, OnDestroy {
  checklistHeaderFound: ChecklistHeaderFindAllResponse[] = []
  allChecklistHeaders: ChecklistHeaderFindAllResponse[] = []

  checklistHeaderTotal = 0

  checklistHeaderLoader = new BehaviorSubject<boolean>(false)

  companyId!: number
  companyName: string = ''
  currentUser: User | null = null
  logoBase64: string | null = null
  logoWidth: number = 0
  logoHeight: number = 0

  idSearch = ''
  visibleIdFilters: { text: string; value: any; checked: boolean }[] = [] // Not used for ID search but keeping structure if needed, or just use simple search

  typeFilters: NzTableFilterList = []
  statusFilters: NzTableFilterList = []
  // User filter properties
  userSearch = ''
  visibleUserFilters: { text: string; value: any; checked: boolean }[] = []
  userFilters: { text: string; value: any; checked: boolean }[] = []

  // Model filter properties
  modelSearch = ''
  visibleModelFilters: { text: string; value: any; checked: boolean }[] = []
  modelFilters: { text: string; value: any; checked: boolean }[] = []

  // Chassis filter properties
  chassisSearch = ''
  visibleChassisFilters: { text: string; value: any; checked: boolean }[] = []
  chassisFilters: { text: string; value: any; checked: boolean }[] = []

  // Active filter conditions
  filterConditions: { [key: string]: any } = {}

  // Pagination properties
  currentPage = 1
  currentPageSize = 10
  filteredChecklistHeaders: ChecklistHeaderFindAllResponse[] = []
  predefinedTypeFilter?: string

  constructor (
    private checklistHeaderService: ChecklistHeaderService,
    private notificationService: NzNotificationService,
    private loaderService: LoaderService,
    private headerService: HeaderService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private authService: AuthService,
    private companyService: CompanyService,
    private imagesService: ImagesService
  ) {}

  ngOnInit (): void {
    this.activatedRoute.params.subscribe(params => {
      if (params['id']) {
        this.companyId = params['id']
        this.fetchCompanyNameAndSearch()
      }
    })

    this.headerService.registerAction(searchString => {
      return this.handleSearchChecklistHeader(1, 10000, searchString)
    }, 'Buscar projeto')

    this.authService.authenticatedUser.subscribe(user => {
      this.currentUser = user
    })

    // Initial load of default logo, will be overwritten if company has one
    this.loadLogo('assets/images/square-logo.png')
  }

  fetchCompanyNameAndSearch () {
    this.companyService.getById(this.companyId).subscribe({
      next: company => {
        this.companyName = company.name
        this.handleSearchChecklistHeader()

        if (company.logo) {
          this.imagesService.photo(company.logo).subscribe(url => {
            if (url) this.loadLogo(url)
          })
        }
      },
      error: () => {
        this.companyName = 'Empresa Desconhecida'
        this.handleSearchChecklistHeader()
      }
    })
  }

  loadLogo (url: string) {
    const img = new Image()
    img.src = url
    img.crossOrigin = 'Anonymous' // Needed if loading from external URL
    img.onload = () => {
      this.logoWidth = img.width
      this.logoHeight = img.height
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      if (ctx) {
        ctx.drawImage(img, 0, 0)
        this.logoBase64 = canvas.toDataURL('image/png')
      }
    }
  }

  ngOnDestroy (): void {
    this.headerService.removeAction()
  }

  backTo (): void {
    this.location.back()
  }

  handleOpenChecklistHeader (id?: number) {
    if (!id) return
    this.route.navigate([`checklist-headers/${id}`])
  }

  handleSearchChecklistHeader (
    pageIndex: number = 1,
    pageSize: number = 10000, // Fetch all data
    searchString?: string
  ) {
    const params: any = {
      pageIndex,
      pageSize,
      searchString,
      companyId: this.companyId
    }

    this.loaderService
      .executeWithLoader(this.checklistHeaderService.findAll(params))
      .subscribe({
        next: ({ items, total }) => {
          const itemsList = items.filter(
            item => item.type !== HeaderTypeEnum.MAINTENANCE
          )
          this.allChecklistHeaders = itemsList
          this.generateFilters()
          this.applyFilters()
        },
        error: (error: HttpErrorResponse) => {
          this.notificationService.error(`${error.status}`, error.error.message)
        }
      })
  }

  generateFilters () {
    // const uniqueIds = new Set(this.allChecklistHeaders.map(item => item.id));
    // this.idFilters = Array.from(uniqueIds).map(id => ({ text: id.toString(), value: id }));

    const uniqueModels = new Set(
      this.allChecklistHeaders.map(item => item.ProductModel.name)
    )
    this.modelFilters = Array.from(uniqueModels).map(name => ({
      text: name,
      value: name,
      checked: false
    }))
    this.visibleModelFilters = [...this.modelFilters]

    const uniqueChassis = new Set(
      this.allChecklistHeaders.map(item => item.chassis)
    )
    this.chassisFilters = Array.from(uniqueChassis).map(chassis => ({
      text: chassis,
      value: chassis,
      checked: false
    }))
    this.visibleChassisFilters = [...this.chassisFilters]

    const uniqueTypes = new Set(this.allChecklistHeaders.map(item => item.type))
    this.typeFilters = Array.from(uniqueTypes).map(type => ({
      text: this.setTypeName(type),
      value: type
    }))

    const uniqueStatuses = new Set(
      this.allChecklistHeaders.map(item => item.status)
    )
    this.statusFilters = Array.from(uniqueStatuses).map(status => ({
      text: this.setStatusColor(status).text,
      value: status
    }))

    const uniqueUsers = new Set(
      this.allChecklistHeaders.map(item => item.UserModel.name)
    )
    this.userFilters = Array.from(uniqueUsers).map(name => ({
      text: name,
      value: name,
      checked: false
    }))
    this.visibleUserFilters = [...this.userFilters]
  }

  onFilterChange (column: string, value: any) {
    this.filterConditions[column] = value
    this.applyFilters()
  }

  onUserSearch (searchValue: string) {
    this.userSearch = searchValue
    this.visibleUserFilters = this.userFilters.filter(item =>
      item.text.toLowerCase().includes(searchValue.toLowerCase())
    )
  }

  applyUserFilter () {
    const selectedUsers = this.userFilters
      .filter(item => item.checked)
      .map(item => item.value)
    this.onFilterChange('user', selectedUsers)
  }

  clearUserFilter () {
    this.userSearch = ''
    this.userFilters.forEach(item => (item.checked = false))
    this.visibleUserFilters = [...this.userFilters]
    this.onFilterChange('user', [])
  }

  onModelSearch (searchValue: string) {
    this.modelSearch = searchValue
    this.visibleModelFilters = this.modelFilters.filter(item =>
      item.text.toLowerCase().includes(searchValue.toLowerCase())
    )
  }

  applyModelFilter () {
    const selectedModels = this.modelFilters
      .filter(item => item.checked)
      .map(item => item.value)
    this.onFilterChange('model', selectedModels)
  }

  clearModelFilter () {
    this.modelSearch = ''
    this.modelFilters.forEach(item => (item.checked = false))
    this.visibleModelFilters = [...this.modelFilters]
    this.onFilterChange('model', [])
  }

  onChassisSearch (searchValue: string) {
    this.chassisSearch = searchValue
    this.visibleChassisFilters = this.chassisFilters.filter(item =>
      item.text.toLowerCase().includes(searchValue.toLowerCase())
    )
  }

  applyChassisFilter () {
    const selectedChassis = this.chassisFilters
      .filter(item => item.checked)
      .map(item => item.value)
    this.onFilterChange('chassis', selectedChassis)
  }

  clearChassisFilter () {
    this.chassisSearch = ''
    this.chassisFilters.forEach(item => (item.checked = false))
    this.visibleChassisFilters = [...this.chassisFilters]
    this.onFilterChange('chassis', [])
  }

  clearAllFilters () {
    this.filterConditions = {}
    this.generateFilters()
    this.applyFilters()
  }

  applyFilters () {
    let filtered = [...this.allChecklistHeaders]

    for (const column in this.filterConditions) {
      const value = this.filterConditions[column]
      if (value && (Array.isArray(value) ? value.length > 0 : true)) {
        if (column === 'id') {
          // filtered = filtered.filter(item => value.includes(item.id));
          // Value for ID is now a search string
          filtered = filtered.filter(item => item.id.toString().includes(value))
        } else if (column === 'model') {
          filtered = filtered.filter(item =>
            value.includes(item.ProductModel.name)
          )
        } else if (column === 'chassis') {
          filtered = filtered.filter(item => {
            const itemChassis = item.chassis ? item.chassis.toUpperCase() : ''
            return value.some((v: string) => v.toUpperCase() === itemChassis)
          })
        } else if (column === 'type') {
          filtered = filtered.filter(item => value.includes(item.type))
        } else if (column === 'status') {
          filtered = filtered.filter(item => value.includes(item.status))
        } else if (column === 'user') {
          filtered = filtered.filter(item =>
            value.includes(item.UserModel.name)
          )
        } else if (column === 'date') {
          if (
            Array.isArray(value) &&
            value.length === 2 &&
            value[0] &&
            value[1]
          ) {
            const startDate = new Date(value[0])
            startDate.setHours(0, 0, 0, 0)

            const endDate = new Date(value[1])
            endDate.setHours(23, 59, 59, 999)

            filtered = filtered.filter(item => {
              if (!item.date) return false
              const itemDate = new Date(item.date)
              return itemDate >= startDate && itemDate <= endDate
            })
          }
        }
      }
    }

    this.filteredChecklistHeaders = filtered
    this.checklistHeaderTotal = filtered.length
    this.currentPage = 1 // Reset to first page on filter change
    this.updateDisplayedData()
  }

  updateDisplayedData () {
    const startIndex = (this.currentPage - 1) * this.currentPageSize
    const endIndex = startIndex + this.currentPageSize
    this.checklistHeaderFound = this.filteredChecklistHeaders.slice(
      startIndex,
      endIndex
    )
  }

  onPageChange (pageIndex: number) {
    this.currentPage = pageIndex
    this.updateDisplayedData()
  }

  onPageSizeChange (pageSize: number) {
    this.currentPageSize = pageSize
    this.currentPage = 1
    this.updateDisplayedData()
  }

  setStatusColor (status: string) {
    switch (status) {
      case 'in_progress':
        return { text: 'Em andamento', color: '#f50' }
      case 'done':
        return { text: 'Finalizado', color: '#87d068' }
      case 'canceled':
        return { text: 'Cancelado', color: '#c0142c' }
      case 'not_proceed':
        return { text: 'Não procede', color: '#cecb13ff' }
      default:
        return { text: 'Desconhecido', color: 'default' }
    }
  }

  setTypeName (type: string) {
    switch (type) {
      case 'new':
        return 'Novo'
      case 'used':
        return 'Usado'
      case 'transfer_start':
        return 'Transferência enviada'
      case 'transfer_done':
        return 'Transferência recebida'
      case 'vehicle':
        return 'Veículo'
      case 'auction':
        return 'Leilão'
      default:
        return ''
    }
  }

  onIdSearch (searchValue: string) {
    this.onFilterChange('id', searchValue)
  }

  clearIdFilter () {
    this.idSearch = ''
    this.onFilterChange('id', '')
  }

  exportToPdf () {
    const doc = new jsPDF('l', 'mm', 'a4') // Landscape for better fit

    // --- Global Header ---
    const pageWidth = doc.internal.pageSize.width
    let currentY = 10
    const marginX = 14

    // 1. Logo (Top Right)
    // Max logo size 25x15 (Width x Height)
    const maxLogoWidth = 25
    const maxLogoHeight = 15

    if (this.logoBase64) {
      // Calculate aspect ratio
      let finalLogoWidth = maxLogoWidth
      let finalLogoHeight = maxLogoHeight

      if (this.logoWidth > 0 && this.logoHeight > 0) {
        const ratio = Math.min(
          maxLogoWidth / this.logoWidth,
          maxLogoHeight / this.logoHeight
        )
        finalLogoWidth = this.logoWidth * ratio
        finalLogoHeight = this.logoHeight * ratio
      }

      // Align top-right: x = pageWidth - marginX - finalLogoWidth
      const logoX = pageWidth - marginX - finalLogoWidth
      doc.addImage(
        this.logoBase64,
        'PNG',
        logoX,
        currentY,
        finalLogoWidth,
        finalLogoHeight
      )
    }

    // Header Text Info (Left Aligned)
    const textStartX = marginX
    let textY = currentY + 5

    doc.setTextColor(0)

    // 2. Company Name (First Line, Bold, Larger)
    doc.setFontSize(14)
    doc.setFont('helvetica', 'bold')
    doc.text(this.companyName || 'Empresa', textStartX, textY)
    textY += 6

    // 3. Report Title
    doc.setFontSize(12)
    doc.text('Check-Lists Realizados', textStartX, textY)
    textY += 10 // Increased spacing below title

    // Reset font for other details
    doc.setFontSize(10)
    doc.setFont('helvetica', 'normal')

    // 4. Date
    const dateStr = new Date().toLocaleString()
    doc.text(`Gerado em: ${dateStr}`, textStartX, textY)
    textY += 5

    // 5. User
    const userName = this.currentUser ? this.currentUser.name : 'Desconhecido'
    doc.text(`Gerado por: ${userName}`, textStartX, textY)
    textY += 5

    // 6. Filters
    const activeFilters: string[] = []
    if (this.idSearch) activeFilters.push(`ID: ${this.idSearch}`)
    if (this.idSearch) activeFilters.push(`ID: ${this.idSearch}`)

    // Model Filter
    if (this.filterConditions['model']?.length) {
      const selectedModels = this.filterConditions['model'].join(', ')
      activeFilters.push(`Modelo: ${selectedModels}`)
    }

    // Chassis Filter
    if (this.filterConditions['chassis']?.length) {
      const selectedChassis = this.filterConditions['chassis'].join(', ')
      activeFilters.push(`Chassis: ${selectedChassis}`)
    }

    // User Filter
    if (this.filterConditions['user']?.length) {
      const selectedUsers = this.filterConditions['user'].join(', ')
      activeFilters.push(`Usuário: ${selectedUsers}`)
    }

    // Categorical filters
    if (this.filterConditions['type']?.length) {
      const selectedTypes = this.filterConditions['type']
        .map((t: any) => this.setTypeName(t))
        .join(', ')
      activeFilters.push(`Tipo: ${selectedTypes}`)
    }

    if (this.filterConditions['status']?.length) {
      const selectedStatuses = this.filterConditions['status']
        .map((s: any) => this.setStatusColor(s).text)
        .join(', ')
      activeFilters.push(`Status: ${selectedStatuses}`)
    }

    // Date filter
    const dateFilter = this.filterConditions['date']
    if (
      Array.isArray(dateFilter) &&
      dateFilter.length === 2 &&
      dateFilter[0] &&
      dateFilter[1]
    ) {
      const d1 = new Date(dateFilter[0]).toLocaleDateString()
      const d2 = new Date(dateFilter[1]).toLocaleDateString()
      activeFilters.push(`Data: ${d1} a ${d2}`)
    }

    if (activeFilters.length > 0) {
      const filterText = `Filtros: ${activeFilters.join(', ')}`
      // Split text if too long. Max width is page width - margin - max logo width - padding
      const maxTextWidth = pageWidth - marginX * 2 - 35 // 35 = maxLogoWidth (25) + padding (10)
      const splitFilters = doc.splitTextToSize(filterText, maxTextWidth)
      doc.text(splitFilters, textStartX, textY)
      // Adjust Y based on lines
      textY += splitFilters.length * 5
    } else {
      doc.text('Filtros: Nenhum', textStartX, textY)
      textY += 5
    }

    // Ensure table starts below the header
    // Use the max of logo bottom or text bottom
    const headerBottom = Math.max(currentY + 20, textY) // 20 = maxLogoHeight (15) + padding (5)
    const tableStartY = headerBottom + 5

    const head = [
      ['ID', 'Modelo', 'Chassis', 'Tipo', 'Status', 'Data', 'Usuário']
    ]
    const data = this.filteredChecklistHeaders.map(item => [
      item.id,
      item.ProductModel.name,
      item.chassis ? item.chassis.toUpperCase() : '',
      this.setTypeName(item.type),
      this.setStatusColor(item.status).text, // Text for Status, will be drawn over
      item.date ? new Date(item.date).toLocaleDateString() : '',
      item.UserModel.name
    ])

    autoTable(doc, {
      startY: tableStartY,
      head: head,
      body: data,
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 4, // Increased padding
        valign: 'middle',
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [192, 20, 44], // Brand Red #c0142c
        textColor: 255,
        fontStyle: 'bold',
        halign: 'center'
      },
      columnStyles: {
        0: { cellWidth: 15, halign: 'center' },
        1: { cellWidth: 35 },
        2: { cellWidth: 40 },
        3: { cellWidth: 30 },
        4: { cellWidth: 35, halign: 'center' }, // Increased width for Status
        5: { cellWidth: 25, halign: 'center' },
        6: { cellWidth: 'auto' }
      },
      didParseCell: data => {
        // Status column is index 4
        if (data.section === 'body' && data.column.index === 4) {
          const rowIndex = data.row.index
          const originalItem = this.filteredChecklistHeaders[rowIndex]

          if (originalItem) {
            const statusInfo = this.setStatusColor(originalItem.status)
            data.cell.styles.textColor = statusInfo.color
            data.cell.styles.fontStyle = 'bold' // Optional: make status text bold
          }
        }
      }
    })

    const sanitizedCompanyName = (this.companyName || 'Empresa').replace(
      /\s+/g,
      '-'
    )
    doc.save(`Check-Lists-${sanitizedCompanyName}.pdf`)
  }
}
